import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import reducers from 'reducers/index';
import Mappers from 'services/integration';
import KapidaMappers from 'services/kapidaIntegration';

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = [thunk];

const mappers =
  $A.TITLE === 'Kapıda Instore' ? new KapidaMappers() : new Mappers();

if (process.env.NODE_ENV === 'development') {
  middleware.push(createLogger());
}

middleware.push((store) => (next) => (action) => {
  next(mappers.bindToModel(action));
});

const AppStore = createStore(
  reducers,
  composeEnhancers(applyMiddleware(...middleware))
);

export default AppStore;



// WEBPACK FOOTER //
// ./src/store/AppStore.js